import { img20, img21, img22, img23 } from "../assets";

const Training = ({ trainingRef }) => {
  return (
    <dev
      ref={trainingRef}
      className="w-screen h-auto bg-[#dceeff] relative flex items-center flex-col"
    >
      <div className="flex flex-col items-center mb-[42px]">
        <div className="text-[#333333] text-[24px] sm:text-[28px] font-[700] mb-[20px] mt-[40px] flex flex-col	items-center">
          <div className="text-center">HUẤN LUYỆN ĐÀO TẠO</div>
          <div className="w-[166px] border-b-[6px] border-[#005DD7] mt-[15px]"></div>
        </div>
        <div className="text-[#585858] text-[20px] sm:text-[24px] font-[500]">
          Lộ trình đào tạo rõ ràng, trực tiếp, chuyên sâu
        </div>
      </div>
      <div className="w-[1136px] max-w-[100vw] px-[20px] flex justify-between	items-center	flex-col-reverse sm:flex-row">
        <div className="lex flex-col">
          <div className="title-training border-b-[2px] border-[#005DD7] w-fit mb-[10px]">
            Từ tháng thứ 1 đến tháng thứ 6
          </div>
          {data1.map((item) => (
            <div className="text-training w-fit">{item}</div>
          ))}
        </div>
        <div className="relative min-w-[342px] h-[325px] sm:min-w-[382px] sm:h-[325px] lg:min-w-[601px] lg:h-[297px]">
          <img
            className="absolute top-0 left-0 z-[5] w-[314px] h-[222px] sm:w-[314px] sm:h-[222px] lg:w-[354px] lg:h-[251px]"
            src={img20}
            alt=""
          />
          <img
            className="absolute bottom-0 right-0 z-[6] w-[230px] h-[164px] sm:w-[230px] sm:h-[164px] lg:w-[306px] lg:h-[217px]"
            src={img21}
            alt=""
          />
        </div>
      </div>
      <div className="w-[1136px] max-w-[100vw] flex items-center pb-[35px] px-[20px] flex-col sm:flex-row">
        <div className="relative min-w-[342px] h-[325px] sm:min-w-[382px] sm:h-[325px] lg:min-w-[530px] lg:h-[297px]">
          <img
            className="absolute top-0 left-0 z-[5] w-[314px] h-[222px] sm:w-[314px] sm:h-[222px] lg:w-[354px] lg:h-[251px]"
            src={img22}
            alt=""
          />
          <img
            className="absolute bottom-0 right-0 z-[6] w-[230px] h-[164px] sm:w-[230px] sm:h-[164px] lg:w-[250px] lg:h-[177px]"
            src={img23}
            alt=""
          />
        </div>
        <div className="flex flex-col w-[100%] sm:w-auto">
          <div className="title-training border-b-[2px] border-[#005DD7] w-fit mb-[10px]">
            Từ tháng thứ 7 trở đi
          </div>
          {data2.map((item) => (
            <div className="text-training w-fit">{item}</div>
          ))}
        </div>
      </div>
    </dev>
  );
};

export default Training;

const data1 = [
  "+ Giới thiệu về bảo hiểm nhân thọ, sản phẩm của BVNT ",
  "+ Phân tích FHC ",
  "+ Phân tích khách hàng tiềm năng ",
  "+ Nghệ thuật đặt câu hỏi, xử lý từ chối, bán chéo sản phẩm trong cùng hệ thống",
];

const data2 = [
  "+ Định hướng thăng tiến cho TVV tiềm năng ",
  "+ Kỹ năng tuyển dụng chất lượng ",
  "+ Quản lý thời gian hiệu quả",
];
